import script from "./koparkaWynik.vue?vue&type=script&async=true&setup=true&lang=ts"
export * from "./koparkaWynik.vue?vue&type=script&async=true&setup=true&lang=ts"

import "./koparkaWynik.vue?vue&type=style&index=0&id=49aff83e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-49aff83e"]])

export default __exports__